import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BloodDonorApi } from '../api/bloodDonor.api';
import { switchMap, map } from 'rxjs/operators';

import { BloodDonorData, BloodDonor } from '../../../interfaces/masters/bloodDonor' ;
@Injectable()
export class BloodDonorService extends BloodDonorData {

    constructor(private api: BloodDonorApi) {
      super();
    }
  
  
    list(url: string): Observable<any[]> {
      
      return this.api.list(url);
    }
  searchList(url: string,data:any): Observable<any> {
     
    return this.api.searchList(url,data);
  }
    getById(url:string): Observable<any>{
        return this.api.getById(url);
    }
  
    create(url: string, data:any): Observable<any[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:any): Observable<any> {
      
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  